<template>
  <b-form
    @submit.prevent="onSubmitForm"
    @reset="onReset"
    class="px-3 py-2"
    style="text-align: left; border: solid 1px #d3d3d3; border-radius: 1vw"
  >
    <dialog :open="isSend" style="z-index:9999; border-color: green;">
      <p>{{ $t('isSend') }}<br>{{ $t('contact-im') }}</p>
      <form method="dialog">
        <b-button class="primary float-right" @click="onReset">{{ $t('close') }}</b-button>
      </form>
    </dialog>
    <b-form-group class="text-center">
      <div
        v-if="appWidth <= 768"
        class="w-100 mb-2 p-2 text-center"
        style="text-shadow: red; border-bottom: 1px solid #d3d3d3"
      >
        {{ $t('contact-form') }}
      </div>
      <div
        class="w-100 mb-2 text-left"
        style="text-shadow: red"
      >
        <span style="font-size: clamp(1rem, 0.75vw + 0.5rem, 3rem);font-weight:bold;">{{  $t('interested-in') }} </span>
        <span style="font-size: clamp(.8rem, 0.5vw + 0.5rem, 2rem)">
         ({{ $t('select-desired') }}):
        </span>
      </div>
      <b-form-radio-group
        id="radio-group-2"
        v-model="form.selected"
        name="radio-sub-component"
        required
      >
        <b-form-radio value="prodaja">{{ $t('sale') }}</b-form-radio>
        <b-form-radio value="nakup">{{ $t('purchase') }}</b-form-radio>
          <br v-if="appWidth <= 768" /> <br v-if="appWidth <= 768" />
        <b-form-radio value="najem">{{ $t('rental') }}</b-form-radio>
        <b-form-radio value="oddaja">{{ $t('lease') }}</b-form-radio>
      </b-form-radio-group>
    </b-form-group>

    <b-form-group id="input-group-2" :label="$t('property-type')" label-for="input-2">
      <b-form-select
        class="ml-3"
        style="width: 95%"
        v-model="form.selectedType"
        :options="nepOptions"
      ></b-form-select>
    </b-form-group>

    <b-form-group id="input-group-2" :label="$t('your-name')" label-for="input-2">
      <b-form-input
        id="input-2"
        class="ml-3"
        style="width: 95%"
        v-model="form.name"
        :placeholder="$t('enter-name')"
        required
      ></b-form-input>
    </b-form-group>
    <b-form-group id="input-group-1" :label="$t('email')" label-for="input-1">
      <b-form-input
        id="input-1"
        class="ml-3"
        style="width: 95%"
        v-model="form.email"
        type="email"
        :placeholder="$t('enter-email')"
        required
      ></b-form-input>
    </b-form-group>

    <b-form-group id="input-group-1" :label="$t('tel-nb')" label-for="input-5">
      <b-form-input
        id="input-5"
        class="ml-3"
        style="width: 95%"
        v-model="form.telst"
        type="text"
        :placeholder="$t('enter-tel-nb')"
        required
      ></b-form-input>
    </b-form-group>

    <b-form-group id="input-group-1" :label="$t('your-message')"
      label-for="input-1"
      :description="$t('email-privacy')"
    >
      <b-form-textarea
        id="textarea"
        class="ml-3"
        style="width: 95%"
        v-model="form.text"
        :placeholder="$t('enter-message')"
        rows="3"
        max-rows="6"
      ></b-form-textarea>
    </b-form-group>

    <b-button type="submit" variant="primary">{{ $t("send-contacts") }}</b-button>
    <!-- <b-button type="reset" variant="danger"></b-button> -->
  </b-form>
</template>
<script>
import api from "@/components/backend-api";
import { mapState } from "vuex";
export default {
  name: "homeContactForm",
  data() {
    return {
      isSend: false,
      form: {
        selected: "prodaja",
        selectedType: null,
        name: "",
        email: "",
        telst: "",
        text: "",
      },
      nepOptions: [
        { value: null, text: this.$t('select-type') },
        { value: 'stanovanje', text: this.$t('apartment') },
        { value: 'hiša', text: this.$t('house') },
        { value: "zemljisce", text: this.$t('land') },
        { value: "poslovni prostor", text: this.$t('business-premise') },
        { value: "drugo", text: this.$t('other') },
      ],
    };
  },
  methods: {
    onSubmitForm() {
      console.log("NOW SEND DATA!");
      api.executePostServerAction("sendMail", { data: this.form }, false)
        .then((response) => {
          this.loadNewPins = false;
          // console.log('SENDING Email')
          // console.log(response)
          if (response.status === 200) {
            if (response.data.error === true) {
              console.log("ERROR sending email!");
              console.log(response.data);
              return false;
            }
            this.form = {
              selected: "prodaja",
              selectedType: null,
              name: "",
              email: "",
              telst: "",
              text: "",
            };
            this.isSend = true;

            // console.log('LOGIN OK!')
            /*
            const pins = response.data.pins
            pins.forEach(el => {
              try {
                if (el.externalContent !== '' && el.externalContent !== 'undefined') {
                  el.externalContent = JSON.parse(el.externalContent)
                } else {
                  el.externalContent = []
                }
              }
              catch (e) {
                el.externalContent = []
              }
            })
            if (this.pins.length === 0 || this.page === 1) {
              this.pins = pins
            } else {
              this.pins.push(...pins)
            }
            this.$store.state.newPins = null
            if (this.pins.length > 0) {
              this.$store.state.lastPin = this.pins[0].id
              localStorage.setItem('lastPinId', this.$store.state.lastPin)
            }
            */
          }
          if (response.data.error === true) {
            console.log("ERROR sending email " + response.status);
            console.log(response.data);
          }
        })
        .catch((error) => {
          // this.loadNewPins = false
          console.log("ERROR SENDING EMAIL!!!");
          console.log(error);
        });
    },
    onReset() {
      this.isSend = false;
    }
  },
  mounted() {},
  computed: {
    ...mapState({
      appWidth: (state) => state.appWidth,
    }),
  },
};
</script>
<style>
  ::backdrop {
    background-image: linear-gradient(
      45deg,
      magenta,
      rebeccapurple,
      dodgerblue,
      green
    );
    opacity: 0.75;
  }
</style>
<i18n>
    {
      "sl": {
        "isSend": "Vaše sporočilo je bilo odposlano!",
        "contact-im": "Kontaktirali vas bomo v najkrajšem možnem času!",
        "close": "Zapri",

        "contact-form": "Kontaktni obrazec",
        "interested-in": "Zanima me",
        "select-desired": "izberite željeno",
        "sale": "prodaja",
        "purchase": "nakup",
        "lease": "najem",
        "rental": "oddaja",

        "select-type": "Izberite vrsto",
        "apartment": "Stanovaje",
        "house": "Hiša",
        "land": "Zemljišče",
        "business-premise": "Poslovni prostor",
        "other": "drugo...",
        "property-type": "Vrsta nepremičnine:",
        "your-name": "Vaše ime:",
        "enter-name": "Vpišite vaše ime in priimek",
        "email": "E-mail naslov:",
        "enter-email": "Vpišite email naslov",
        "tel-nb": "Telefonska številka:",
        "enter-tel-nb": "Vpišite telefonsko številko",
        "your-message": "Vaše sporočilo:",
        "enter-message": "Vpišite sporočilo...",

        "send-contacts": "Pošljite povpraševanje",
        "email-privacy": "Vaših osebnih podatkov ne bomo nikoli delili s komerkoli."
      },
      "de": {
        "isSend": "Ihre Nachricht wurde gesendet!",
        "contact-im": "Wir werden Sie so schnell wie möglich kontaktieren!",
        "close": "Schließen",

        "contact-form": "Kontaktformular",
        "interested-in": "Ich bin interessiert",
        "select-desired": "gewünschtes auswählen",
        "sale": "Verkauf",
        "purchase": "Einkauf",
        "lease": "Vermiete",
        "rental": "Miete",

        "select-type": "Wählen Sie einen Typ",
        "apartment": "Wohnung",
        "house": "Haus",
        "land": "Land",
        "business-premise": "Geschäftsräume",
        "other": "andere...",
        "property-type": "Eigenschaftstyp:",
        "your-name": "Ihr Name:",
        "enter-name": "Geben Sie Ihren Vor- und Nachnamen ein",
        "email": "E-Mail-Adresse:",
        "enter-email": "E-Mail-Adresse eingeben",
        "tel-nb": "Telefonnummer:",
        "enter-tel-nb": "Telefonnummer eingeben",
        "your-message": "Ihre Nachricht:",
        "enter-message": "Geben Sie eine Nachricht ein...",

        "send-contacts": "Senden Sie eine Anfrage",
        "email-privacy": "Wir werden Ihre persönlichen Daten niemals an Dritte weitergeben."
      },
      "en": {
        "isSend": "Your message has been sent!",
        "contact-im": "We will contact you as soon as possible!",
        "close": "Close",

        "contact-form": "Contact form",
        "interested-in": "Interested in",
        "select-desired": "select desired",
        "sale": "sale",
        "purchase": "purchase",
        "lease": "lease",
        "rental": "rental",

        "select-type": "Select type",
        "apartment": "Apartment",
        "house": "House",
        "land": "Land",
        "business-premise": "Business premises",
        "other": "other...",
        "property-type": "Property type:",
        "your-name": "Your name:",
        "enter-name": "Enter your first and last name",
        "email": "Email address:",
        "enter-email": "Enter email address",
        "tel-nb": "Phone number:",
        "enter-tel-nb": "Enter phone number",
        "your-message": "Your message:",
        "enter-message": "Enter message...",

        "send-contacts": "Send an inquiry",
        "email-privacy": "We'll never share your personal information with anyone."
      }
    }
</i18n>
